import { AxiosError } from 'axios';
import { setMessage } from 'slices/notification';
import store from 'store';
import type { HttpErrorResponse } from 'types/shared';

class HttpError {
  private ERROR_CODE: Record<string, string> = {
    common: 'common',
    forbidden: 'forbidden',
    err_network: 'err_network',
    unexpected_error: 'unexpected_error',
    unauthorized: 'unauthorized',
    'user.not_existed': 'user.not_existed',
    'user.existed': 'user.existed',
    'user.wrong_password': 'user.wrong_password',
    'user.login_locked': 'user.login_locked',
    'user.create_success': 'user.create_success',
    'user.update_success': 'user.update_success',
    'user.delete_success': 'user.delete_success',
    'token.invalid': 'token.invalid',
    'email.not_existed': 'email.not_existed',
    'role.existed_name': 'role.existed_name',
    'role.not_existed': 'role.not_existed',
    'role.create_success': 'role.create_success',
    'role.update_success': 'role.update_success',
    'role.delete_success': 'role.delete_success',

    'member.no_identity': 'member.no_identity',
    'member.visa_invalidate': 'member.visa_invalidate',
    'member.passport_invalidate': 'member.passport_invalidate',
  };

  public unwrap(error: AxiosError<HttpErrorResponse>) {
    const { code, response } = error;

    if (code === AxiosError.ERR_NETWORK) {
      store.dispatch({
        type: setMessage.type,
        payload: 'err_network',
      });
    } else if (response) {
      const { status, data } = response;

      switch (status) {
        case 403: {
          store.dispatch({
            type: setMessage.type,
            payload: 'forbidden',
          });
          break;
        }
        default: {
          if (data && typeof data === 'object' && 'MessageCode' in data) {
            store.dispatch({
              type: setMessage.type,
              payload: data['MessageCode'],
            });
          } else {
            store.dispatch({
              type: setMessage.type,
              payload: 'common',
            });
          }
          break;
        }
      }
    }

    return Promise.reject(error);
  }

  public parse(messageCode: string | null) {
    const prefixTranslateKey = 'messages';

    if (typeof messageCode === 'string' && messageCode in this.ERROR_CODE) {
      return `${prefixTranslateKey}.${this.ERROR_CODE[messageCode]}`;
    }

    return `${prefixTranslateKey}.common`;
  }
}

export default new HttpError();
